
import {
  sharedControls,
} from '@superset-ui/chart-controls';
import {
  DataRecord,
  DataRecordValue,
  getMetricLabel,
  getColumnName,
  isSavedMetric,
  isAdhocMetricSimple,
  QueryFormMetric,
  t,
} from '@superset-ui/core';
import { number } from 'echarts';

export const CONSTANTS = {
  combinedMetricLabel: 'Combined'
};

export const requiredEntity = {
  ...sharedControls.entity,
  clearable: false,
};

export const optionalEntity = {
  ...sharedControls.entity,
  clearable: true,
  validators: [],
};

export const commonControlsConfig = {
  combineMetrics: {
    type: 'CheckboxControl',
    label: t('Combine Metrics'),
    description: t(
      'Combine metrics into a Total column',
    ),
    renderTrigger: true,
  },
  tooltipFormat: {
    type: 'TextControl',
    label: t('Tooltip Format'),
    description: t(
      'String template for tooltip format. Ex: {b}: {c}. ' +
      '{a} for series name, {b} for category name, {c} for data value.'
    ),
    renderTrigger: true,
  }
};

export interface MetricSeriesData {
  [metricLabel: string]: {
    name: string,
    data: DataRecordValue[],
    total?: number
  }
};

function sum(arr: number[]): number {
  return arr.reduce((sum, current) => sum + current, 0);
}

function combine_by_aggregate(values: number[], metric: QueryFormMetric): number {
  if (isSavedMetric(metric)) {
    return sum(values);
  }
  if (isAdhocMetricSimple(metric)) {
    if (metric.aggregate === 'MAX') {
      return Math.max(...values);      
    }
    if (metric.aggregate === 'MIN') {
      return Math.min(...values);
    }
    if (metric.aggregate === 'AVG') {
      return Math.round((sum(values) / values.length) * 1000) / 1000;
    }
  }
  return sum(values);;
}

export function getMetricSeriesData (
  metrics: QueryFormMetric[],
  data: DataRecord[],
  combineMetrics?: boolean): MetricSeriesData
  {
  const multiMetricData: MetricSeriesData = {};
  metrics.forEach(metric => {
    const metricLabel = getMetricLabel(metric);
    multiMetricData[metricLabel] = { name: metricLabel, data: [] }
    data.forEach(datum => {
      multiMetricData[metricLabel].data.push(datum[metricLabel]);
    });
    if (combineMetrics) {
      multiMetricData[metricLabel].total = combine_by_aggregate(
        multiMetricData[metricLabel].data.map(val => number.numericToNumber(val)), metric);
    }
  });
  return multiMetricData;
}
export function getColumnNamePosition(metrics: QueryFormMetric[],dbhdsRegionColumnName: string): number{
  let columnPosition=0;
  metrics.forEach((metric,index) =>{
    const columnName: any= getColumnName(metric) || "";;
    if(columnName===dbhdsRegionColumnName){
      columnPosition=index;
    }
  });
  return columnPosition;

}
export function getSeriesKeys(
  labels: string[], combinedMetricLabel?: string): string[] {
  return combinedMetricLabel ? [...labels, combinedMetricLabel] : labels;
}
